export default __webpack_public_path__ + "static/section2-eletrical-b6aa1d42620e1a555ed536db50e5f475.webp";